import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TEmExportFileRequest,
	TEmExportRequest,
	TEmExportResponsePayload,
	TEmExportsStore,
} from './types';

// ==========================================:
export const initialState: TEmExportsStore = {
	exportOrders: null,
	exportOrdersLoader: false,
	exportReturns: null,
	exportReturnsLoader: false,
	downloadFileLoader: false,
	downloadFileError: null,
};

// ==========================================:
const emExports = createSlice({
	name: '@@emExports',
	initialState,
	reducers: {
		exportOrdersRequest: (state: TEmExportsStore, action: PayloadAction<TEmExportRequest>) => {
			const emExportsState = state;
			emExportsState.exportOrdersLoader = true;
		},
		exportOrdersSuccess: (
			state: TEmExportsStore,
			action: PayloadAction<TEmExportResponsePayload>,
		) => {
			const { payload } = action;
			const emExportsState = state;
			emExportsState.exportOrders = payload;
			emExportsState.exportOrdersLoader = false;
		},
		exportOrdersFailure: (state: TEmExportsStore) => {
			const emExportsState = state;
			emExportsState.exportOrdersLoader = false;
		},
		exportReturnsRequest: (state: TEmExportsStore, action: PayloadAction<TEmExportRequest>) => {
			const emExportsState = state;
			emExportsState.exportReturnsLoader = true;
		},
		exportReturnsSuccess: (
			state: TEmExportsStore,
			action: PayloadAction<TEmExportResponsePayload>,
		) => {
			const { payload } = action;
			const emExportsState = state;
			emExportsState.exportReturns = payload;
			emExportsState.exportReturnsLoader = false;
		},
		exportReturnsFailure: (state: TEmExportsStore) => {
			const emExportsState = state;
			emExportsState.exportReturnsLoader = false;
		},
		downloadEmExportFileRequest: (
			state: TEmExportsStore,
			action: PayloadAction<TEmExportFileRequest>,
		) => {
			const emExportsState = state;
			emExportsState.downloadFileLoader = true;
			emExportsState.downloadFileError = null;
		},
		downloadEmExportFileSuccess: (state: TEmExportsStore) => {
			const emExportsState = state;
			emExportsState.downloadFileLoader = false;
			emExportsState.downloadFileError = null;
		},
		setDownloadEmExportFileError: (state: TEmExportsStore, action: PayloadAction<string>) => {
			const { payload } = action;
			const emExportsState = state;
			emExportsState.downloadFileLoader = false;
			emExportsState.downloadFileError = payload;
		},
		emExportsInitState: () => initialState,
	},
});

export default emExports.reducer;
export const {
	exportOrdersRequest,
	exportOrdersSuccess,
	exportOrdersFailure,
	exportReturnsRequest,
	exportReturnsSuccess,
	exportReturnsFailure,
	downloadEmExportFileRequest,
	downloadEmExportFileSuccess,
	setDownloadEmExportFileError,
	emExportsInitState,
} = emExports.actions;
